export const userStatusOptions = [
  { label: 'Todos', value: '' },
  { label: 'Ativo', value: 'enabled' },
  { label: 'Inativo', value: 'disabled' },
  { label: 'Pendente', value: 'pending' },
]